import { motion } from "framer-motion";
import { Leaf, Sparkles, Sprout, Users, Truck } from "lucide-react";

const SERVICES = [
  {
    title: "Pulizia Aree Verdi",
    desc: "Sfalcio, potatura e manutenzione ordinaria e straordinaria di parchi, giardini e spazi verdi pubblici e privati.",
    span: "md:col-span-7",
    badge: "VERDE",
    icon: Leaf,
  },
  {
    title: "Pulizie Private Interni ed Esterni",
    desc: "Servizi di pulizia completi per abitazioni, villaggi turistici e aziende, dentro e fuori.",
    span: "md:col-span-5",
    badge: "PULIZIE",
    icon: Sparkles,
  },
  {
    title: "Progettazione Aree Verdi",
    desc: "Progettiamo nuovi spazi verdi su misura per privati, aziende ed enti: dal disegno alla realizzazione.",
    span: "md:col-span-4",
    badge: "PROGETTAZIONE",
    icon: Sprout,
  },
  {
    title: "Gestione Dipendenti",
    desc: "Coordinamento del personale e delle turnazioni per la tua attività, con un referente dedicato.",
    span: "md:col-span-4",
    badge: "GESTIONE",
    icon: Users,
  },
  {
    title: "Trasporti, Sgomberi e Traslochi",
    desc: "Traslochi completi, trasporti di ogni tipo e sgomberi di cantine, garage, uffici e locali.",
    span: "md:col-span-4",
    badge: "LOGISTICA",
    icon: Truck,
  },
];

export default function Features() {
  return (
    <section id="funzionalita" data-testid="features-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-mono text-xs uppercase tracking-[0.25em] text-neon"
        >
          {"// I Nostri Servizi"}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="mt-4 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl"
        >
          Cinque servizi, <span className="text-pulse">un'unica squadra.</span>
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-12">
          {SERVICES.map((f, i) => (
            <motion.article
              key={f.title}
              data-testid={`feature-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden rounded-2xl border border-[#D9E4F5] bg-white p-6 shadow-[0_8px_32px_rgba(22,52,95,0.08)] transition-all duration-500 hover:-translate-y-1 hover:border-neon/50 lg:p-8 ${f.span}`}
            >
              <div
                aria-hidden
                className="pointer-events-none absolute -inset-24 opacity-0 transition-opacity duration-700 group-hover:opacity-100"
                style={{
                  background:
                    "radial-gradient(circle at 50% 0%, rgba(53,101,174,0.10), transparent 60%)",
                }}
              />
              <div className="relative">
                <div className="flex items-start justify-between gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-neon/30 bg-neon/10">
                    <f.icon className="h-5 w-5 text-neon" />
                  </span>
                  <span className="rounded-full border border-pulse/40 bg-pulse/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-pulse">
                    {f.badge}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-lg font-medium sm:text-xl">{f.title}</h3>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
                  {f.desc}
                </p>
                <span className="mt-6 block h-px w-10 bg-neon/50 transition-all duration-500 group-hover:w-full group-hover:bg-neon" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
